import TableWithTitle from "@/components/TableWithTitle.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import { getDescriptionBasedOnKpiKey, getColorsBasedOnRange, transformGoogleSheetFromCSV } from "@/utils/transformers";
import { SELECTOR, CUSTOMER_PERIOD_FIELD, ACTIVE_CUSTOMER_12M, NEW_CUSTOMERS_MONTH, MONTHLY_NET_ACQUISITION, PCT_NEW_CUSTOMERS, CHURNED_CUSTOMERS_12M_MONTH, CAC, PCT_CHURNED_CUSTOMERS_12M, REACTIVATED_CUSTOMERS_MONTH, AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M, AVG_AOV_12M, AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M, MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M, PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES, PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH } from "@/utils/table_fields";
import AppIcon from "@/components/AppIcon.vue";
import { mapState } from "vuex";
import { HugValue, DateValue, RateChangeValue, CurrencyValue, NumberValue, BoxedValue, BarWithValue, PercentageValue, DottedValue, OverlapBarValue, EvolutionArrow, SegmentedBar, ImageElement, HashedNumberValue, DottedPositionBar, DashedPositionBar, BarWithDifferenceFromMaxMarked, RangeBar, DotElement, ValueElement } from "@/components/tableElements";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import DownloadMixin from "@/mixins/DownloadMixin.vue";
import TasksMixin from "@/mixins/TasksMixin.vue";
import { DEFAULT_DATE_FORMATS, DAYS_INVENTORY_HEATMAP_COLORS, ORGANIC_CVR_HEATMAP_COLORS, BUYBOX_HEATMAP_COLORS, PERIOD_COLUMN_TITLES, COLORS } from "@/utils/constants";
import FlexRow from "@/components/FlexRow.vue";
import moment from "moment";
import { capitalize } from "vue";
import SlotWithEvolutionValue from "@/components/tableElements/SlotWithEvolutionValue.vue";
import EvolutionValue from "@/components/tableElements/EvolutionValue.vue";
import WrapTableWithShowMore from "@/components/WrapTableWithShowMore.vue";
import TextValue from "@/components/tableElements/TextValue.vue";
export default {
  name: "PeriodTable",
  components: {
    TableWithTitle,
    WrapWithPopover,
    AppIcon,
    HugValue,
    DateValue,
    RateChangeValue,
    CurrencyValue,
    NumberValue,
    BoxedValue,
    BarWithValue,
    PercentageValue,
    DottedValue,
    OverlapBarValue,
    FlexRow,
    SlotWithEvolutionValue,
    EvolutionValue,
    WrapTableWithShowMore,
    TextValue,
    EvolutionArrow,
    SegmentedBar,
    ImageElement,
    HashedNumberValue,
    DottedPositionBar,
    DashedPositionBar,
    BarWithDifferenceFromMaxMarked,
    RangeBar,
    DotElement,
    ValueElement
  },
  mixins: [LiteTableMixin, DownloadMixin, TasksMixin],
  props: {
    loading: {
      typ: Boolean,
      required: true
    }
  },
  emits: ["setDateRange", "refresh"],
  data() {
    return {
      DAYS_INVENTORY_HEATMAP_COLORS,
      ORGANIC_CVR_HEATMAP_COLORS,
      BUYBOX_HEATMAP_COLORS,
      PERIOD_COLUMN_TITLES,
      COLORS,
      fields: [SELECTOR, CUSTOMER_PERIOD_FIELD, ACTIVE_CUSTOMER_12M, MONTHLY_NET_ACQUISITION, NEW_CUSTOMERS_MONTH, PCT_NEW_CUSTOMERS, CAC, CHURNED_CUSTOMERS_12M_MONTH, PCT_CHURNED_CUSTOMERS_12M, REACTIVATED_CUSTOMERS_MONTH, AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M, AVG_AOV_12M, AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M, MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M, PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES, PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH],
      evolCategory: {
        prev_period: "_evol_vs_previous_period_pc",
        same_period_ly: "_evol_vs_last_year_pc"
      },
      csvSources: period => ({
        [PERIOD_COLUMN_TITLES[period]]: `period_agg`,
        [ACTIVE_CUSTOMER_12M.label]: ACTIVE_CUSTOMER_12M.key,
        [`${ACTIVE_CUSTOMER_12M.label} Previous Period Evolution`]: `${ACTIVE_CUSTOMER_12M.key}_evol_vs_previous_period_pc`,
        [`${ACTIVE_CUSTOMER_12M.label} Same Period Last Year Evolution`]: `${ACTIVE_CUSTOMER_12M.key}_evol_vs_last_year_pc`,
        [MONTHLY_NET_ACQUISITION.label]: MONTHLY_NET_ACQUISITION.key,
        [`${MONTHLY_NET_ACQUISITION.label} Previous Period Evolution`]: `${MONTHLY_NET_ACQUISITION.key}_evol_vs_previous_period_pc`,
        [`${MONTHLY_NET_ACQUISITION.label} Same Period Last Year Evolution`]: `${MONTHLY_NET_ACQUISITION.key}_evol_vs_last_year_pc`,
        [NEW_CUSTOMERS_MONTH.label]: NEW_CUSTOMERS_MONTH.key,
        [`${NEW_CUSTOMERS_MONTH.label} Previous Period Evolution`]: `${NEW_CUSTOMERS_MONTH.key}_evol_vs_previous_period_pc`,
        [`${NEW_CUSTOMERS_MONTH.label} Same Period Last Year Evolution`]: `${NEW_CUSTOMERS_MONTH.key}_evol_vs_last_year_pc`,
        [PCT_NEW_CUSTOMERS.label]: PCT_NEW_CUSTOMERS.key,
        [`${PCT_NEW_CUSTOMERS.label} Previous Period Evolution`]: `${PCT_NEW_CUSTOMERS.key}_evol_vs_previous_period_pc`,
        [`${PCT_NEW_CUSTOMERS.label} Same Period Last Year Evolution`]: `${PCT_NEW_CUSTOMERS.key}_evol_vs_last_year_pc`,
        [CAC.label]: CAC.key,
        [`${CAC.label} Previous Period Evolution`]: `${CAC.key}_evol_vs_previous_period_pc`,
        [`${CAC.label} Same Period Last Year Evolution`]: `${CAC.key}_evol_vs_last_year_pc`,
        [CHURNED_CUSTOMERS_12M_MONTH.label]: CHURNED_CUSTOMERS_12M_MONTH.key,
        [PCT_CHURNED_CUSTOMERS_12M.label]: PCT_CHURNED_CUSTOMERS_12M.key,
        [REACTIVATED_CUSTOMERS_MONTH.label]: REACTIVATED_CUSTOMERS_MONTH.key,
        [AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M.label]: AVG_REVENUE_PER_ACTIVE_CUSTOMER_12M.key,
        [AVG_AOV_12M.label]: AVG_AOV_12M.key,
        [AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M.label]: AVG_PURCHASE_PER_ACTIVE_CUSTOMER_12M.key,
        [MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M.label]: MEDIAN_TIME_BETWEEN_PURCHASES_DAYS_12M.key,
        [PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES.label]: PCT_ACTIVE_CUSTOMERS_12M_WITH_2PLUS_PURCHASES.key,
        [PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH.label]: PCT_REVENUE_SUBSCRIBE_AND_SAVE_MONTH.key
      })
    };
  },
  computed: {
    ...mapState({
      periodTable: state => state.customer_insights.periodTable,
      tab: state => state.customer_insights.currentTabValue,
      period: state => state.customer_insights.period,
      currentPeriod: state => state.customer_insights.currentPeriod,
      periodCategory: state => state.customer_insights.periodCategory
    }),
    items() {
      return this.periodTable[this.tab]?.items;
    },
    maxCharCount() {
      return this.periodTable[this.tab]?.maxCharCount;
    },
    minMax() {
      return this.periodTable[this.tab]?.minMax;
    },
    getDateValueFormat() {
      // Convert the current period to UPPER CASE
      const period = this.period.toUpperCase();
      return DEFAULT_DATE_FORMATS[period];
    },
    getPeriodColumnTitle() {
      return PERIOD_COLUMN_TITLES[this.period];
    },
    period_pager: {
      get() {
        return this.periodTable.period_page;
      },
      set(_) {
        this.$store.dispatch("customerInsightsIncrementPeriodPage");
        this.$emit("refresh");
      }
    },
    customerNumberFormat() {
      return num => {
        if (num >= 1_000) return (num / 1000).toFixed(1) + "K";
        return num;
      };
    },
    avgCustomerPurchaseFormat() {
      return num => {
        return num.toFixed(2) + "x";
      };
    },
    computedMedTimePurchaseDay() {
      return num => {
        return Math.round(num) + "d";
      };
    },
    csvFileName() {
      return `Customer_Insights_Performance_Evolution_${capitalize(this.period)}.csv`;
    }
  },
  methods: {
    getDescriptionBasedOnKpiKey,
    getColorsBasedOnRange,
    handleDateClick(period) {
      period = moment(period);
      this.$emit("setDateRange", period);
    },
    handleDateReset() {
      this.$emit("setDateRange", null);
    },
    handleRowClick(item) {
      this.handleRowClicked(item, this.handleDateReset, this.handleDateClick, "period_agg");
    },
    async downloadPerformancePeriodCSV() {
      const csv_headers = this.csvSources(this.period);
      const csvFileName = this.csvFileName;
      const str = await this.generateCsvString(csv_headers, this.prepareCsvRowsForDownload(this.items, csv_headers), 1, "-");
      await this.downloadCsv(str, csvFileName);
      this.trackDashboardCsvExport();
    },
    async copyPerformancePeriodCSV() {
      const csv_headers = this.csvSources(this.period);
      const str = await this.generateCsvString(csv_headers, this.prepareCsvRowsForDownload(this.items, csv_headers), 1, "-");
      await this.copyCSV(str);
    },
    async downloadPerformanceGoogleSheet() {
      const csv_headers = this.csvSources(this.period);
      const rowData = this.prepareCsvRowsForDownload(this.items, csv_headers);
      const data = transformGoogleSheetFromCSV(csv_headers, rowData);
      const task = await this.downloadCSVWithGoogleSheets("/customer_insights/generate/googlesheet", {
        sheet_name: this.csvFileName,
        task_type: "google_sheet_generation",
        data
      });

      //console.log('dashboard task', task);

      if (!task) {
        return;
      }
      this.sheetGenerationTaskIdentifier = task.task_id;
      this.executeTaskStatusHandler(task);
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifier);
    },
    handleRunning() {
      this.checkTaskStatusPeriodically(this.sheetGenerationTaskIdentifier);
    },
    handleFailed(data) {
      this.exportLoading = false;
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Google sheet generation Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
      throw new Error("Google sheet generation Task failed");
    },
    async handleFinished(data) {
      //console.log('dashboard finished', data);
      if (data) {
        const {
          task_result: {
            share_link
          }
        } = data;
        if (this.asyncUpdateInterval) {
          clearTimeout(this.asyncUpdateInterval);
          this.asyncUpdateInterval = null;
        }
        window.$bus.trigger("showSuccess", {
          visible: true,
          message: "The google sheet has been successfully generated. A link has been sent to your email.",
          delay: 60 // Show alert less than 60 secs
        });
        this.exportLoading = false;
        if (share_link) window.open(share_link, "_blank");
      }
    }
  }
};